module.exports = __webpack_public_path__ + "img/Frame-20.57e7797a.svg";